import { ModuleWithProviders, NgModule } from '@angular/core';

import { RECAPTCHA_V3_SITE_KEY, ReCaptchaV3ConfigFactory } from './ReCaptchaV3SiteKey';



@NgModule({})
export class ReCaptchaV3Module {
  static forRoot(reCaptchaConfigFactory: ReCaptchaV3ConfigFactory): ModuleWithProviders<ReCaptchaV3Module> {
    return {
      ngModule: ReCaptchaV3Module,
      providers: [
        {
          provide: RECAPTCHA_V3_SITE_KEY,
          useFactory: reCaptchaConfigFactory
        }
      ]
    };
  }
}
